module.exports = __webpack_public_path__ + "img/zichan.f248d084.png";